"use client";

import Image from "next/image";
import { PhoneCall } from "lucide-react";
import Link from "next/link";
import MBFooter from "@/components/footer/mobileFooter";
import ftrLogo from "@/../public/assets/images/ftr-Logo.svg";
import linkedinIcon from "@/../public/assets/images/icons8-linkedin.svg";
import { About, Service } from "@/app/shared/type";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";

interface FooterProps {
  services: Service[];
  about: About | null;
}
export default function Footer({ services, about }: FooterProps) {
const sectionTitles: string[] = [];
if (about) {
  (about as any).sections?.forEach((section: any) => {
    sectionTitles.push(section.title);
  });
}
  return (
    <footer className="nimbus-container bg-black text-white px-4 py-10">
    <div className="deskfooter">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Logo Section */}
        <div className="md:col-span-1">
          <Image src={ftrLogo} alt="Nimbus Node Logo" width={200} height={100} />
        </div>

        {/* Link Groups */}
        <div className="md:col-span-3 grid grid-cols-2 sm:grid-cols-3 gap-6">
          {/* Services Section */}
          <div className="font-poppins">
            <h5 className="font-semibold mb-2">Services</h5>
            <div>
              {services.length > 0 ? (
                <>
                  {services.slice(0, 5).map((service) => (
                    <Link
                      key={service.slug}
                      href={`/services#${service.slug}`}
                      className="text-sm text-white py-1 mb-1 font-medium hover:text-cyan-400 transition-colors block"
                    >
                      {service.name}
                    </Link>
                  ))}
                  {services.length > 5 && (
                    <Link
                      href="/services"
                      className="text-sm text-cyan-400 py-1 mb-1 font-medium hover:text-cyan-300 transition-colors block"
                    >
                      + More Services
                    </Link>
                  )}
                </>
              ) : (
                <p className="text-sm text-white py-1 mb-1">Loading...</p>
              )}
            </div>
          </div>

          {/* Quicklinks Section */}
          <div className="font-poppins">
            <h5 className="font-semibold mb-2">Quicklinks</h5>
            <p className="text-sm text-white py-1 mb-1">About Us</p>
            <p className="text-sm text-white py-1 mb-1">Our Commitment</p>
            <p className="text-sm text-white py-1 mb-1">Our Values</p>
            {/* {sectionTitles.length > 0 ? (
              sectionTitles.map((name, idx) => (
                <p key={idx} className="text-sm text-white py-1 mb-1">
                  {name}
                </p>
              ))
            ) : (
              <p className="text-sm text-white py-1 mb-1">Loading...</p>
            )} */}
          </div>

          {/* Careers (static for now) */}
          {/* <div>
            <h5 className="font-semibold mb-2">Careers</h5>
            <p className="text-sm text-white py-1 mb-1">Current Openings</p>
            <p className="text-sm text-white py-1 mb-1">Share Your Resume</p>
            <p className="text-sm text-white py-1 mb-1">Our Benefits</p>
          </div> */}

          {/* Contact Us (static for now) */}
          <div>
            <h5 className="font-poppins font-semibold mb-2">Contact Us</h5>
            {/* <p className="text-sm text-white py-1 mb-1">
              <Link href={"mailto:rohit@nimbusnode.co"}>CEO’s email</Link>
            </p>
            <p className="text-sm text-white py-1 mb-1">
              <Link href={"mailto:ankit@nimbusnode.co"}>CTO’s email</Link>
            </p>
            <p className="text-sm text-white py-1 mb-1">
              <Link href={"mailto:hr@nimbusnode.co"}>CHRO</Link>
            </p> */}
            {/* Phone */}
            <div className="flex items-start gap-3 mb-2">
              <FontAwesomeIcon icon={faPhone} className="text-blue-500 text-lg mt-1" />
              <div className="font-poppins">
                {/* <h3 className="font-semibold">Call Us</h3> */}
                <Link title="+91 9646237320" href="tel:+919646237320" className="text-white">Call Us</Link>
                {/* <Link href="tel:+919646237320" className="text-white">+91 9646237320</Link> */}
              </div>
            </div>

            {/* Email */}
            <div className="flex items-start gap-3 mb-6">
              <FontAwesomeIcon icon={faEnvelope} className="text-blue-500 text-lg mt-1" />
              <div className="font-poppins">
                {/* <h3 className="font-semibold">Email Us at</h3> */}
                <Link title="contactus@nimbusnode.co" href="mailto:contactus@nimbusnode.co" className="text-white">Email Us</Link>
                {/* <Link href="mailto:contactus@nimbusnode.co" className="text-white">contactus@nimbusnode.co</Link> */}
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        
      </div>

      <div className="mid-footer">
              <div className="flex space-x-6 linkedin-btn">
              
              </div>
              <div className="">
                <p className="font-poppinstext-sm mb-3 md:text-right">Let's Work Together</p>
                <div className="linkedin-btn">
                  <Link target="blank" href="https://www.linkedin.com/company/nimbus-node">LinkedIn
                    <Image src={linkedinIcon} alt="LinkedIn" width={30} height={30} />
                  </Link>
                </div>
              </div>
      </div>
      {/* Socials and Bottom Row */}
      <div className="max-w-7xl mx-auto mt-10 border-t border-gray-600 pt-6 text-sm flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="text-center md:text-left">© 2025 Nimbus Node</div>
        <Link href="#" className="text-white hover:underline">
          Privacy Policy
        </Link>
      </div>
    </div>

    <div className="mbfooter">
      <MBFooter services={services} />
    </div>
      
    </footer>
  );
}
